module.exports = __webpack_public_path__ + "static/img/logo.e2f65e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = Z2Ou
// module chunks = 7